import { AppLanguage, AppLanguageType } from '../../types/appTypes';
import esLocale from '@fullcalendar/core/locales/es';
import enLocale from '@fullcalendar/core/locales/en-gb';
import deLocale from '@fullcalendar/core/locales/de';
import frLocale from '@fullcalendar/core/locales/fr';
import { LocaleInput } from '@fullcalendar/core';
import {
    CalendarEvent,
    CalendarFirstDayOfWeek,
    CalendarFirstDayOfWeekType,
} from '../../types/calendar/calendarTypes';
import {
    endOfWeek,
    formatDayMonth,
    formatMonthYear,
    startOfMonth,
    startOfWeek,
} from '../formatDates';

export const getCalendarLocaleData = (language: AppLanguageType) => {
    let locale: LocaleInput;
    let firstDay: CalendarFirstDayOfWeekType;

    switch (language) {
        case AppLanguage.SPANISH:
            locale = esLocale;
            firstDay = CalendarFirstDayOfWeek.MONDAY;
            break;
        case AppLanguage.GERMAN:
            locale = deLocale;
            firstDay = CalendarFirstDayOfWeek.MONDAY;
            break;
        case AppLanguage.FRENCH:
            locale = frLocale;
            firstDay = CalendarFirstDayOfWeek.MONDAY;
            break;
        case AppLanguage.ENGLISH:
            locale = enLocale;
            firstDay = CalendarFirstDayOfWeek.SUNDAY;
            break;
        default:
            locale = enLocale;
            firstDay = CalendarFirstDayOfWeek.SUNDAY;
            break;
    }
    return { locale, firstDay };
};

export const getMonthsWithEvents = (events: CalendarEvent[], lang: string) => {
    const months = [...new Set(events.map(e => startOfMonth(e.start)))].sort();
    return months.map(m => ({
        value: m,
        label: formatMonthYear(m, lang),
    }));
};

export const getWeeksWithEvents = (
    events: CalendarEvent[],
    lang: string,
    firstDay: CalendarFirstDayOfWeekType
) => {
    const weeks = [
        ...new Set(events.map(e => startOfWeek(e.start, firstDay))),
    ].sort();
    return weeks.map(w => ({
        value: w,
        label: `${formatDayMonth(w, lang)} - ${formatDayMonth(
            endOfWeek(w, firstDay),
            lang
        )}`,
    }));
};
